// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Refresh: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 34" enableBackground="new 0 0 34 34" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" d="M33.67,14.92V0.33l-4.9,4.9C25.75,2.21,21.6,0.33,17,0.33
	C7.79,0.33,0.35,7.79,0.35,17c0,9.21,7.44,16.67,16.65,16.67c7.77,0,14.25-5.31,16.1-12.5h-4.33C27.06,26.02,22.44,29.5,17,29.5
	c-6.9,0-12.5-5.6-12.5-12.5c0-6.9,5.6-12.5,12.5-12.5c3.46,0,6.54,1.44,8.79,3.71l-6.71,6.71H33.67z"/>
</svg>;
};

export default React.memo(Refresh);
